export const EVENT_ACTION = 'tv';
export const METRICS_EVENT_TYPE_EXECUTOR = 'executor';
export const NOT_THANKS_ACTION = 'noTanks';
export const SUSCRIPTION_CHANEL_MODAL_NAME = 'SuscriptionChannel';
export const SUSCRIPTION_FOX_TEXT = 'suscripción fox';

export const PRODUCT_FORCED_LABEL = 'Contrata ahora ';
export const PROVIDER_SUSC_CANCEL_BUTTON = 'No, Gracias';
export const FOX_PLUS_PREMIUM_SUC_TITLE = '¡Suscribete a FOX PREMIUM!';
export const FOX_PLUS_SUSC_DESCRIPTION =
  'Para ver este canal necesitas una suscripción activa a FOX PREMIUM';

export const classButtonInactive = 'btn btn-default close-modal btn-to-modal';
export const classButtonActive = 'btn btn-default btn-to-modal';
